import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=a28c34c6&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28c34c6')) {
      api.createRecord('a28c34c6', component.options)
    } else {
      api.reload('a28c34c6', component.options)
    }
    module.hot.accept("./documentList.vue?vue&type=template&id=a28c34c6&", function () {
      api.rerender('a28c34c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/documentList.vue"
export default component.exports